import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'access-request-controls',
  template: `
    <div class="row button-row">
      <div class="col-md-8">&nbsp;</div>
      <div class="col-md-4">
        <select class="form-control form-control-sm" [ngModel]="requestType" (change)="load($event)">
          <option value="ALL">All</option>
          <option value="DENIED">Denied</option>
          <option value="GRANTED">Granted</option>
          <option value="PENDING">Pending</option>
        </select>
      </div>
    </div>
    
  `,
  styles: [`
    .button-row {
      margin-bottom:10px;
    }
  `]
})
export class AccessRequestControlsComponent {
  @Input() requestType: string;
  @Output() loadRequests: EventEmitter<string> = new EventEmitter();

  load (e: any) {
    this.loadRequests.emit(e.target.value);
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/access-request-controls.ts